(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        var defaultState = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.initialState = initialState ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : defaultState;
        this.nextId = 1;
        this.tiles = [];
        this.state = [
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ]
        ];
        for(var r = 0; r < 4; r++){
            for(var c = 0; c < 4; c++)if (this.initialState[r][c] !== 0) {
                var tile = {
                    id: this.nextId++,
                    value: this.initialState[r][c],
                    r: r,
                    c: c
                };
                this.state[r][c] = tile;
                this.tiles.push(tile);
            }
        }
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getTiles",
            value: function getTiles() {
                return this.tiles;
            }
        },
        {
            key: "getState",
            value: function getState() {
                var arr = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    var tile = this.state[r][c];
                    if (tile) arr[r][c] = tile.value;
                }
                return arr;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomCell();
                this.addRandomCell();
                this.checkEndGame();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.nextId = 1;
                this.tiles = [];
                this.state = [
                    [
                        null,
                        null,
                        null,
                        null
                    ],
                    [
                        null,
                        null,
                        null,
                        null
                    ],
                    [
                        null,
                        null,
                        null,
                        null
                    ],
                    [
                        null,
                        null,
                        null,
                        null
                    ]
                ];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.initialState[r][c] !== 0) {
                        var tile = {
                            id: this.nextId++,
                            value: this.initialState[r][c],
                            r: r,
                            c: c
                        };
                        this.state[r][c] = tile;
                        this.tiles.push(tile);
                    }
                }
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "addRandomCell",
            value: function addRandomCell() {
                var emptyCells = [];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (!this.state[r][c]) emptyCells.push({
                        r: r,
                        c: c
                    });
                }
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], r1 = _emptyCells_Math_floor.r, c1 = _emptyCells_Math_floor.c;
                    var tile = {
                        id: this.nextId++,
                        value: Math.random() < 0.9 ? 2 : 4,
                        r: r1,
                        c: c1,
                        isNew: true
                    };
                    this.state[r1][c1] = tile;
                    this.tiles.push(tile);
                }
            }
        },
        {
            key: "checkEndGame",
            value: function checkEndGame() {
                var has2048 = false;
                var hasEmpty = false;
                var hasMoves = false;
                var arr = this.getState();
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (arr[r][c] >= 2048) has2048 = true;
                    if (arr[r][c] === 0) hasEmpty = true;
                    if (c < 3 && arr[r][c] === arr[r][c + 1]) hasMoves = true;
                    if (r < 3 && arr[r][c] === arr[r + 1][c]) hasMoves = true;
                }
                if (has2048) this.status = "win";
                else if (!hasEmpty && !hasMoves) this.status = "lose";
            }
        },
        {
            key: "move",
            value: function move(direction) {
                var _this, _loop = function(i) {
                    var lineTiles = [];
                    var getCoords = function(lineIndex, cellIndex) {
                        switch(direction){
                            case "left":
                                return {
                                    r: lineIndex,
                                    c: cellIndex
                                };
                            case "right":
                                return {
                                    r: lineIndex,
                                    c: 3 - cellIndex
                                };
                            case "up":
                                return {
                                    r: cellIndex,
                                    c: lineIndex
                                };
                            case "down":
                                return {
                                    r: 3 - cellIndex,
                                    c: lineIndex
                                };
                            default:
                                return {
                                    r: 0,
                                    c: 0
                                };
                        }
                    };
                    for(var j = 0; j < 4; j++){
                        var _getCoords = getCoords(i, j), r = _getCoords.r, c = _getCoords.c;
                        if (_this.state[r][c] !== null) lineTiles.push(_this.state[r][c]);
                    }
                    var newLine = [];
                    var k = 0;
                    while(k < lineTiles.length)if (k + 1 < lineTiles.length && lineTiles[k].value === lineTiles[k + 1].value) {
                        lineTiles[k].value *= 2;
                        lineTiles[k].isMerged = true;
                        _this.tiles = _this.tiles.filter(function(t) {
                            return t !== lineTiles[k + 1];
                        });
                        newLine.push(lineTiles[k]);
                        addedScore += lineTiles[k].value;
                        k += 2;
                    } else {
                        newLine.push(lineTiles[k]);
                        k++;
                    }
                    while(newLine.length < 4)newLine.push(null);
                    for(var j1 = 0; j1 < 4; j1++){
                        var _getCoords1 = getCoords(i, j1), r1 = _getCoords1.r, c1 = _getCoords1.c;
                        var item = newLine[j1];
                        if (_this.state[r1][c1] !== item) moved = true;
                        _this.state[r1][c1] = item;
                        if (item) {
                            item.r = r1;
                            item.c = c1;
                        }
                    }
                };
                if (this.status !== "playing") return;
                this.tiles.forEach(function(t) {
                    t.isNew = false;
                    t.isMerged = false;
                });
                var moved = false;
                var addedScore = 0;
                for(var i = 0; i < 4; i++)_this = this, _loop(i);
                if (moved) {
                    this.score += addedScore;
                    this.addRandomCell();
                    this.checkEndGame();
                }
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.move("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.move("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.move("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.move("down");
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".button.start");
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$msgStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$msgWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$msgLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$started = false;
var $197cd56b15c33885$var$firstMoveDone = false;
function $197cd56b15c33885$var$render() {
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    var score = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$scoreEl.textContent = score;
    var tilesEl = document.querySelector(".tiles-container");
    var renderedTiles = Array.from(tilesEl.children);
    var activeTiles = $197cd56b15c33885$var$game.getTiles();
    activeTiles.forEach(function(tile) {
        var tileEl = document.getElementById("tile-".concat(tile.id));
        if (!tileEl) {
            tileEl = document.createElement("div");
            tileEl.id = "tile-".concat(tile.id);
            tilesEl.appendChild(tileEl);
        }
        tileEl.className = "tile tile--".concat(tile.value, " field-cell--").concat(tile.value);
        if (tile.isNew) tileEl.classList.add("is-new");
        else tileEl.classList.remove("is-new");
        if (tile.isMerged) tileEl.classList.add("is-merged");
        else tileEl.classList.remove("is-merged");
        tileEl.textContent = tile.value;
        tileEl.style.setProperty("--r", tile.r);
        tileEl.style.setProperty("--c", tile.c);
    });
    var activeIds = new Set(activeTiles.map(function(t) {
        return "tile-".concat(t.id);
    }));
    renderedTiles.forEach(function(el) {
        if (!activeIds.has(el.id)) el.remove();
    });
    if (gameStatus === "playing") {
        $197cd56b15c33885$var$msgStart.classList.add("hidden");
        $197cd56b15c33885$var$msgWin.classList.add("hidden");
        $197cd56b15c33885$var$msgLose.classList.add("hidden");
    } else if (gameStatus === "win") {
        $197cd56b15c33885$var$msgWin.classList.remove("hidden");
        $197cd56b15c33885$var$msgStart.classList.add("hidden");
        $197cd56b15c33885$var$msgLose.classList.add("hidden");
    } else if (gameStatus === "lose") {
        $197cd56b15c33885$var$msgLose.classList.remove("hidden");
        $197cd56b15c33885$var$msgStart.classList.add("hidden");
        $197cd56b15c33885$var$msgWin.classList.add("hidden");
    } else if (gameStatus === "idle") {
        $197cd56b15c33885$var$msgStart.classList.remove("hidden");
        $197cd56b15c33885$var$msgWin.classList.add("hidden");
        $197cd56b15c33885$var$msgLose.classList.add("hidden");
    }
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if (!$197cd56b15c33885$var$started) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$started = true;
        $197cd56b15c33885$var$render();
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$startButton.classList.remove("restart");
        $197cd56b15c33885$var$startButton.classList.add("start");
        $197cd56b15c33885$var$started = false;
        $197cd56b15c33885$var$firstMoveDone = false;
        $197cd56b15c33885$var$render();
    }
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var oldState = JSON.stringify($197cd56b15c33885$var$game.getState());
    if (e.key === "ArrowUp" || e.key.toLowerCase() === "w") $197cd56b15c33885$var$game.moveUp();
    if (e.key === "ArrowDown" || e.key.toLowerCase() === "s") $197cd56b15c33885$var$game.moveDown();
    if (e.key === "ArrowLeft" || e.key.toLowerCase() === "a") $197cd56b15c33885$var$game.moveLeft();
    if (e.key === "ArrowRight" || e.key.toLowerCase() === "d") $197cd56b15c33885$var$game.moveRight();
    var newState = JSON.stringify($197cd56b15c33885$var$game.getState());
    if (oldState !== newState && !$197cd56b15c33885$var$firstMoveDone) {
        $197cd56b15c33885$var$firstMoveDone = true;
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    }
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$render();

})();
//# sourceMappingURL=2048-game.085d9358.js.map
